import { apiGet, apiPatch } from './client';

// A row of the BankImportDefs registry (the management screen's grid model).
export interface BankImportDefRow {
  importId: number;
  importName: string;
  bankId: number;
  format: string;
  importType: string;
  sourceKind: string;
  filePattern: string | null;
  /**
   * The client-group splitter this import is FOR, when the files can't say it themselves.
   * Discount ships folders 666 / 521 and a browser upload never sends the folder name, so
   * the definition declares it. Empty = the file carries its own splitter (Poalim reads it
   * from the XML) or the bank has none.
   */
  splitterCode: string | null;
  lastImportDate: string | null;
  lastValueDate: string | null;
  isActive: boolean;
}

interface BatchRequest {
  added: BankImportDefRow[];
  modified: BankImportDefRow[];
  deleted: number[];
}

export function getBankImportDefs(): Promise<BankImportDefRow[]> {
  return apiGet<BankImportDefRow[]>('/api/bank-imports');
}

export function saveBankImportDefsBatch(
  added: BankImportDefRow[],
  modified: BankImportDefRow[],
  deletedIds: number[],
): Promise<BankImportDefRow[]> {
  return apiPatch<BatchRequest, BankImportDefRow[]>('/api/bank-imports/batch', {
    added,
    modified,
    deleted: deletedIds,
  });
}

// One active import definition + how today's run (for the target date) finished.
export interface BankImportStatusRow {
  importId: number;
  importName: string;
  bankId: number;
  derivedStatus: 'done' | 'error' | 'inProgress' | 'missing';
  derivedStatusHe: string;
}

// Per-tenant daily ingestion status (today by default). Tenant via X-Tenant-Id.
export function getBankImportsStatus(opts?: { tenantId?: number }): Promise<BankImportStatusRow[]> {
  return apiGet<BankImportStatusRow[]>('/api/bank-imports/status', opts);
}
